import { authLogout } from "@my-langguth/auth-ui";
import { whoAmIOptions } from "@/client/@tanstack/react-query.gen";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { retryFunc } from "@/api/retry";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";
import { useNavigate } from "@tanstack/react-router";
import { SHOP_AUTH_API_BASE } from "@/lib/shop-auth-api-base";

export function useAuth() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const logoutMutation = useMutation({
    mutationFn: () => authLogout(SHOP_AUTH_API_BASE),
    onSuccess: async () => {
      queryClient.removeQueries({ queryKey: whoAmIOptions().queryKey });
      toast.success(t("auth.loggedOut"));
      await navigate({
        to: "/login",
        search: { redirect: undefined },
        replace: true,
      });
    },
    onError: (error) => {
      console.error("Logout failed:", error);
      toast.error(t("auth.logoutFailed"));
    },
  });

  const {
    data: user,
    isLoading,
    error,
  } = useQuery({
    ...whoAmIOptions(),
    retry: retryFunc,
  });

  const logout = () => {
    logoutMutation.mutate();
  };

  return {
    user,
    isAuthenticated: !!user && !error,
    isLoading: isLoading,
    isCustomerUser: user?.type === "customer",
    isLangguthUser: user?.type === "langguth",
    customerId: user?.customerId,
    logout,
  };
}
